import { proApiSlice } from '../../store/proApiSlice';

export const extendedApiSlice = proApiSlice
  .enhanceEndpoints({ addTagTypes: [] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getPlusPrices: builder.query({
      query: () => ({
        url: 'register/prices',
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetPlusPricesQuery,
} = extendedApiSlice;